
export const REPORT_DEFINITIONS = [
   {
    id: "daily_tran_all",
    name: "Daily Total Transactions by State and UserID",
    group: "Transaction Reports",
    inputs: ["startDate", "endDate"]
  }
  ,{
    id: "month_tran",
    name: "Monthly Transaction Report",
    group: "Transaction Reports",
    inputs: ["month", "year"]
  },
  {
    id: "tran_fed_st",
    name: "Total CDLIS Transactions by Federal and State Users",
    group: "Transaction Reports",
    inputs: ["startDate", "endDate"]
  },
  {
    id: "tran_division",
    name: "Total CDLIS Transactions per State and FMCSA Division",
    group: "Transaction Reports",
    inputs: ["startDate", "endDate"]
  },
  {
    id: "tran_category",
    name: "Total Transactions by Category",
    group: "Transaction Reports",
    inputs: ["startDate", "endDate"]
  },
  {
    id: "tran_count",
    name: "Transaction Count Report (Summary by Month/Year)",
    group: "Transaction Reports",
    inputs: ["startDate", "endDate"]
  },
  {
    id: "disabled_acct_range",
    name: "Date Range Disabled Accounts Report",
    group: "Account / Directory Reports",
    inputs: ["startDate", "endDate"]
  },
  {
    id: "disabled_acct",
    name: "Standard Disabled Accounts Report",
    group: "Account / Directory Reports",
    inputs: []
  },
  {
    id: "active_dir",
    name: "Active Directory User Report",
    group: "Account / Directory Reports",
    inputs: []
  },
  {
    id: "CDLIS_user",
    name: "CDLIS User Account Report",
    group: "Account / Directory Reports",
    inputs: []
  }
];

export const usStates = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" }
];

export const months = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" }
];

export const years = ["2026", "2025", "2024", "2023", "2022"];